import { Component, Output, EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BzgModalService, BzgToastService, BzgToastType, PageEvent } from 'bz-genome-angular';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { DetailConfirmJobsModalComponent } from '../../../common-components/modals/detail-confirm-jobs-modal/detail-confirm-jobs-modal.component';
import { DetailJobsModalComponent } from '../../../common-components/modals/detail-jobs-modal/detail-jobs-modal.component';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import {
  getUIPathCurrentConnector
} from '../../../store/selectors/rpa-uipath-conn.selector';

import {
  getUIPathJobsListSelector,
  UIPathRetryJobSelector
} from '../../../store/selectors/rpa-uipath-dashboard.selector';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { IUipathJob } from 'app/rpa-bots/uipath/common/models/IUipathJob';

@Component({
  selector: 'biz-uipath-job-retries',
  templateUrl: './uipath-job-retries.component.html',
  styleUrls: ['./uipath-job-retries.component.scss']
})
export class UipathJobRetriesComponent {
  @Output() retryJob = new EventEmitter<any>();
  @Output() resetJob = new EventEmitter<any>();

  public jobRetried$: Observable<any>;
  public uiPathConnection$: Observable<IRpaConnectionUiPath>;
  public headers: string[];
  public items: any[];
  public pageSize = 10;
  public pageIndex = 0;
  public totalItems: number;
  public showFirstLastButtons = true;
  public hidePageSizeSelector = false;
  public event: PageEvent;
  public jobRetriedSubscriber: any;
  public uiPathConnectionSubscriber: any;
  public dataJobSubsriber: any;

  dataJob$: Observable<IODataResponse<IUipathJob[]>>;

  dataJob: IUipathJob[];
  private _userModalSubscription: Subscription;
  private currentUiPathConnection: IRpaConnectionUiPath;

  pager: any = {};
  pageOfItems: any[];

  constructor(
    private _translateService: TranslateService,
    private _toastService: BzgToastService,
    private _modalService: BzgModalService,
    private _store: Store<IAppState>,
    private _translate: TranslateService,
    private _i18nService: I18nService,
    private _showToastService: ShowToastService
  ) {
    this._translate
      .get([
        'RPA_BOTS.DETAIL',
        'RPA_BOTS.NAME',
        'RPA_BOTS.STATUS',
        'RPA_BOTS.CREATION_TIME',
        'RPA_BOTS.TYPE',
        'RPA_BOTS.ROBOT',
        'RPA_BOTS.MACHINE_NAME',
        'RPA_BOTS.RETRY'
      ])
      .subscribe((data: any) => {
        this.headers = [
          data['RPA_BOTS.DETAIL'],
          data['RPA_BOTS.NAME'],
          data['RPA_BOTS.STATUS'],
          data['RPA_BOTS.CREATION_TIME'],
          data['RPA_BOTS.TYPE'],
          data['RPA_BOTS.ROBOT'],
          data['RPA_BOTS.MACHINE_NAME'],
          data['RPA_BOTS.RETRY']
        ];
      });

    this.uiPathConnection$ = this._store.pipe(
      select(getUIPathCurrentConnector)
    );
    this.uiPathConnectionSubscriber = this.uiPathConnection$.subscribe(
      uiPathConnection => (this.currentUiPathConnection = uiPathConnection)
    );

    this.jobRetried$ = this._store.pipe(select(UIPathRetryJobSelector));
    this.dataJob$ = this._store.pipe(
      select(getUIPathJobsListSelector)
    );

    this.dataJobSubsriber = this.dataJob$.subscribe(response => {
      if (response) {
        this.dataJob = response.value || [];
        this.totalItems = this.dataJob.length;
        this.items = this.items = this.dataJob.slice(
          this.pageSize * this.pageIndex,
          this.pageSize * this.pageIndex + this.pageSize < this.dataJob.length
            ? this.pageSize * this.pageIndex + this.pageSize
            : this.dataJob.length
        );
      } else {
        this.dataJob = [];
        this.totalItems = 0;
        this.items = [];
      }
    });

    this.jobRetriedSubscriber = this.jobRetried$.subscribe(jobId => {
      if (jobId !== null) {
        this._translateService
            .get('RPA_BOTS.JOB_ID_RETRY', { jobId: jobId })
            .subscribe((message: string) => {
              this._showToastService.showToast(message, 'success');
            });
        this.resetJob.emit();
      }
    });
  }

  ngOnDestroy() {
    if (this.jobRetriedSubscriber) {
      this.jobRetriedSubscriber.unsubscribe();
    }
    if (this.uiPathConnectionSubscriber) {
      this.uiPathConnectionSubscriber.unsubscribe();
    }
    if (this.dataJobSubsriber) {
      this.dataJobSubsriber.unsubscribe();
    }
  }

  openConfirmModal(job: IUipathJob) {
    const modalRef = this._modalService.open(DetailConfirmJobsModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      closeOnEscape: false,
      data: job
    });

    this._userModalSubscription = modalRef
      .afterClosed()
      .subscribe(async (modalData: any) => {
        if (modalData && modalData.Id) {
          const inputArguments =
            job.InputArguments === null ? '' : job.InputArguments;
          const jobKey = job.ReleaseName.split('_')[0];

          this.retryJob.emit({ jobKey, inputArguments });
        }
      });
  }

  openDetailModal(job: IUipathJob) {
    const modalRef = this._modalService.open(DetailJobsModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      closeOnEscape: false,
      data: job
    });

    this._userModalSubscription = modalRef
      .afterClosed()
      .subscribe(async (modalData: any) => { });
  }

  onPaginationEvent(event: PageEvent) {
    this.event = event;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.totalItems = event.totalItems;
    if (this.dataJob) {
      this.items = this.dataJob.slice(
        this.pageSize * this.pageIndex,
        this.pageSize * this.pageIndex + this.pageSize < this.dataJob.length
          ? this.pageSize * this.pageIndex + this.pageSize
          : this.dataJob.length
      );
    }
  }
}
